import styled from "styled-components";

export const Section = styled.div`
  margin-bottom: 4rem;
`;

export const Heading1 = styled.h1`
  text-align: center;
  color: #6d214f;
`;

export const Heading2 = styled.h2`
  text-align: center;
  color: rgba(109, 33, 79, 0.5);
`;

export const HorizontalLine = styled.hr`
  background-color: rgba(109, 33, 79, 0.1);
  border: 0;
  height: 1px;
  margin-bottom: 1.6em;
`;
